module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-236.6bc92ce.woff2";